<template>
    <div class="dashboard wh-full"
         :style="styles.root">
        <!-- Header -->
        <page-header :returnable="false"
                     class="py-0">
            <el-tabs v-model="activeTab"
                     @tab-click="goTo">
                <el-tab-pane v-for="tab in tabs"
                             :key="tab.name"
                             :name="tab.name"
                             :label="tab.label"
                             class="font-default" />
            </el-tabs>
        </page-header>

        <!-- Body -->
        <router-view />
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

import PageHeader from '@/components/layout/PageHeader'

const labels = {
  aboutCommon: 'Общая информация',
  aboutUsers: 'Статистика стройконтроля',
  aboutComments: 'Последние комментарии'
}

export default {
  components: {
    PageHeader
  },
  data() {
    return {
      labels,
      activeTab: null
    }
  },
  computed: {
    ...mapGetters('account', ['hasAccess']),

    tabs() {
      return [
        { name: 'project.about.common', label: labels.aboutCommon },
        ...this.hasAccess({ permissions: 'project_comments_show' }) && [{ name: 'project.about.comments', label: labels.aboutComments }] || [],
        { name: 'project.about.users', label: labels.aboutUsers }
      ]
    },

    styles() {
      return {
        root: `
          display: grid;
          grid-template-rows: min-content 1fr;
        `
      }
    }
  },
  mounted() {
    this.activeTab = this.$route.name
  },
  methods: {
    getSelectionType(name) {
      return this.$route.name === name ? 'primary' : null
    },

    goTo({ name }) {
      this.$router.push({ name })
    }
  }
}
</script>

<style lang="scss">
.dashboard {
  .el-tabs {
    &__header {
      margin-bottom: 0;
    }

    &__item {
      height: 3rem;
      line-height: 3rem;
      font-weight: 400;
    }
  }
}
</style>
